
import { Link } from "react-router-dom";
import AkkhorLayout from "../../layout/AkkhorLayout";
import List from "../../component/List";

export default function ListGdKh() {
    let params = '';
    const columns = [
        { name: "id", label: "ID" },
        {
            name: "fullname", label: "Thông tin khách hàng",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    
                    return <div>
                        <div className="w-100 flex">
                            <span>Họ tên: </span>
                            <strong>{value}</strong>
                        </div>
                        <div className="w-100 flex">
                            <span>Số điện thoại: </span>
                            <strong>{tableMeta.mobile}</strong>
                        </div>
                    </div>
                },
            }
        },
        {
            name: "status", label: "Trạng thái",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    if (value == 1) return "Hoạt động"
                    if (value == 0) return "Ngừng hoạt động"
                    return null
                },
            }
        },
        { name: "author", label: "Người tạo" },
        { name: "datecreate", label: "Ngày tạo", }
    ];

    return (<AkkhorLayout idrole="khach-hang">
        <div className="breadcrumbs-area">
            <ul>
                <li>
                    <Link to="/">Trang chủ</Link>
                </li>
                <li>
                    Quản lý khách hàng
                </li>
            </ul>
        </div>
        <List name="customers" idrole="khach-hang" params={params} title="" defaultLimit={50} serverSide={true} columns={columns}></List>
    </AkkhorLayout>);
}
